import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgArrowUp = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={31}
    height={25}
    viewBox='0 0 31 25'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d='M30.3536 4.35355C30.5488 4.15829 30.5488 3.84171 30.3536 3.64645L27.1716 0.464466C26.9763 0.269204 26.6597 0.269204 26.4645 0.464466C26.2692 0.659728 26.2692 0.976311 26.4645 1.17157L29.2929 4L26.4645 6.82843C26.2692 7.02369 26.2692 7.34027 26.4645 7.53553C26.6597 7.7308 26.9763 7.7308 27.1716 7.53553L30.3536 4.35355ZM0 24.5H10.2941V23.5H0V24.5ZM15.7941 19V9H14.7941V19H15.7941ZM20.2941 4.5H30V3.5H20.2941V4.5ZM15.7941 9C15.7941 6.51472 17.8088 4.5 20.2941 4.5V3.5C17.2566 3.5 14.7941 5.96243 14.7941 9H15.7941ZM10.2941 24.5C13.3317 24.5 15.7941 22.0376 15.7941 19H14.7941C14.7941 21.4853 12.7794 23.5 10.2941 23.5V24.5Z'
      fill='#93949A'
    />
  </svg>
);
export default SvgArrowUp;
